// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { CookieService } from 'ngx-cookie-service';
import { ListApiResponseV2 } from 'src/app/shared/interfaces/_base/api-response.interface';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

import { VideoViewInterface } from '../models/video-view/video-view.interface';

@Injectable({
  providedIn: 'root'
})
export class VideoViewService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService,
    private cookieService: CookieService
  ) { }


  /**
   * Create a new video view
   *
   * @since 1.0.0
   *
   * @param data VideoView data
   */
  create(data: VideoViewInterface): Observable<any> {
    return this.apiService.apiCall('POST', 'videos-views', data);
  }

  /**
   * Get videos views list for given query params
   *
   * @since 1.0.0
   *
   * @param [start] Query left offset
   * @param [limit] Results number
   * @param [sort] Sorting field name
   * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
   * @param [search] Filtering object with fildering data string
   */
  getSuppliersVideoList(companyId: string, start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    const params: any = { start, limit, sort, sortVersus};
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService.apiCall('GET', `videos-views/suppliers/${companyId}`, params);
  }

  /**
   * Get videos views list for given query params
   *
   * @since 1.0.0
   *
   * @param [start] Query left offset
   * @param [limit] Results number
   * @param [sort] Sorting field name
   * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
   * @param [search] Filtering object with fildering data string
   */
  getResidentsVideoList(companyId: string, start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    const params: any = { start, limit, sort, sortVersus};
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService.apiCall('GET', `videos-views/residents/${companyId}`, params);
  }
  
  /**
   * Get an exportation file of supplier type of videos views of the company
   *
   * @since 1.0.0
   */
  getSuppliersVideoExport(companyId: string): Observable<any> {
    return this.apiService.apiCall('GET', `videos-views/suppliers-export/${companyId}`, {}, { responseType: 'blob' })
      .pipe(
        catchError(err => {
          return this.helperService.parseErrorBlob(err);
        })
      );
  }
  
  /**
   * Get an exportation file of resident type of videos views of the company
   *
   * @since 1.0.0
   */
  getResidentsVideoExport(companyId: string): Observable<any> {
    return this.apiService.apiCall('GET', `videos-views/residents-export/${companyId}`, {}, { responseType: 'blob' })
      .pipe(
        catchError(err => {
          return this.helperService.parseErrorBlob(err);
        })
      );
  }
}  